module.exports = __webpack_public_path__ + "static/media/pagelines.9e8fc2cb.svg";